import { convertObjectToParams } from '../../components/common/create-params';

export const UserRole = {
  ADMIN: 'administrator',
  MANAGERS: 'MANAGERS',
  CLIENTS: 'client_administrator',
};

export const defaultListenerParams = {
  page: 1,
  limit: 25,
  search: '',
  order_by_direction: 'desc',
  order_by: 'created_at',
};

export const Clients = [
  { path: '/groups', text: 'Groups', id: 'Groups' },
  // { path: '/clients', text: 'Clients', id: 'Clients' },
  // { path: '/billing', text: 'Billing', id: 'Billing' },
  { path: '/templates/comms', text: 'Templates', id: 'Templates' },
];

export const Engagement = [
  { path: '/checkins', text: 'Check-Ins', id: 'Check-Ins' },
  { path: '/requests', text: 'Requests', id: 'Requests' },
  { path: '/calls', text: 'Calls', id: 'Calls' },
  { path: '/topics', text: 'Topics', id: 'Topics' },
  { path: '/stories', text: 'Stories', id: 'Stories' },
];

export const users = [
  { path: '/members', text: 'Members', id: 'Members' },
  {
    path:
      '/listeners' +
      convertObjectToParams({
        ...defaultListenerParams,
        user_type: 'peerlistener',
      }),
    text: 'Peer Listeners',
    id: 'Listeners',
  },
  {
    path:
      '/peers' +
      convertObjectToParams({
        ...defaultListenerParams,
        user_type: 'peer',
      }),
    text: 'Peers',
    id: 'Peers',
  },
  // { path: '/Demographics', text: 'Demographics', id: 'Demographics' },
];

export const textBlock = [
    { path: '/text-block/members', text: 'Text Blocks', id: 'TextBlocks' },
    { path: '/files', text: 'Files', id: 'Files' },
    { path: '/users', text: 'Users', id: 'Users' },
    // { path: 'text-block/client-admin', text: 'Demographics', id: 'Demographics' },
];

export const DashBoard = [{ path: '/dashboard', text: 'Dashboard', id: 'Dashboard' }];

export const admin = [
  { path: '/user-safety/user-management', text: 'User Safety', id: 'Safety' },
  { path: '/listeners-reviews/messages', text: 'Review', id: 'Review' },
  { path: '/calls', text: 'Calls', id: 'Calls' },
  { path: '/settings', text: 'Settings', id: 'Settings' },
  { path: '/resources', text: 'Resources', id: 'Resources' },
  { path: '/tiers', text: 'Tiers', id: 'Tiers' },
  { path: '/tag-groups', text: 'Tags', id: 'Tags' },
  // { path: '/legacy', text: 'Partners(Legacy)', id: 'Legacy' },
];

export const clientPortal = [
  { path: '/snapshot', text: 'Snapshot', id: 'Snapshot' },
  { path: '/engagement', text: 'Engagement', id: 'Engagement' },
  { path: '/eligibility', text: 'Eligibility', id: 'Eligibility' },
  // { path: '/group-manager', text: 'Group Manager', id: 25 },
  // { path: '/member-resources', text: 'Member Resources', id: 26 },
  // { path: '/marketing-library', text: 'Marketing Library', id: 27 },
];
